import axios from 'axios';
import { IBezahlmgl } from '@/shared/model/bezahlmgl.model';
const baseApiUrl = 'api/bezahlmgl';

export default class BezahlmglService {
  public retrieve(): Promise<any> {
    return axios.get(`${baseApiUrl}`);
  }

  public delete(id: number): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .delete(`${baseApiUrl}/${id}`)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public find(id: number): Promise<IBezahlmgl> {
    return new Promise<IBezahlmgl>((resolve, reject) => {
      axios
        .get(`${baseApiUrl}/${id}`)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public create(entity: IBezahlmgl): Promise<IBezahlmgl> {
    return new Promise<IBezahlmgl>((resolve, reject) => {
      axios
        .post(`${baseApiUrl}`, entity)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public update(entity: IBezahlmgl): Promise<IBezahlmgl> {
    return new Promise<IBezahlmgl>((resolve, reject) => {
      axios
        .put(`${baseApiUrl}`, entity)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }
}
